export const FileTypes = {
    ZIP: "ZIP",
    XLSX: "XLSX",
    IMAGE: "IMAGE",
    AUDIO: "AUDIO",
    VIDEO: "VIDEO",
    DOCUMENT: "DOCUMENT",
  };